import * as moment from "moment";
import {TransactionEventApiDto} from "../../../api/model/rest";
import User from "../../user/User";
import {Option} from "ts-option";
import {getUser} from "../../../store/view/user";
import AuthenticatedEntity, {AuthenticatedEntityTypeEnum} from "../../user/AuthenticatedEntity";
import IndividualContact from "../../contact/IndividualContact";
import {getIndividualContact} from "../../../store/view/contact";
import {store} from "../../../navigation/ReduxProvider";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import Attachment from "../../attachment/Attachment";
import ActivityEvent from "../../event/ActivityEvent";
import TransactionPaymentReconciledEvent from "./TransactionPaymentReconciledEvent";
import TransactionPaymentReceivedEvent from "./TransactionPaymentReceivedEvent";
import TransactionPaymentUnreconciledEvent from "./TransactionPaymentUnreconciledEvent";
import TransactionPaymentPartiallyReconciledEvent from "./TransactionPaymentPartiallyReconciledEvent";

/**
 * Transaction event model.
 */
export default class TransactionEvent extends ActivityEvent {

	/**
	 * @param {string} id identifier of event.
	 * @param {TransactionEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 */
	constructor(public readonly id: string,
		public readonly type: TransactionEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment) {
		super();
	}

	public static fromJson(json: TransactionEventApiDto): TransactionEvent {
		let type: TransactionEventTypeEnum;
		switch (json.type) {
			case TransactionEventTypeEnum.PaymentReceived:
				type = TransactionEventTypeEnum.PaymentReceived;
				break;
			case TransactionEventTypeEnum.PaymentReconciled:
				type = TransactionEventTypeEnum.PaymentReconciled;
				break;
			case TransactionEventTypeEnum.UndoReconciliation:
				type = TransactionEventTypeEnum.UndoReconciliation;
				break;
			case TransactionEventTypeEnum.PaymentPartiallyReconciled:
				type = TransactionEventTypeEnum.PaymentPartiallyReconciled;
				break;
			default:
				type = TransactionEventTypeEnum.PaymentReceived;
		}
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new TransactionEvent(json.id, type, creator, moment(json.creationDateTime));
	}

	getCssClass() {
		return '';
	}

	getIcon() {
		return Icon.New;
	}

	getIconColor(): IconColor {
		return IconColor.Blue;
	}

	getAttachments(): Attachment[] {
		return [];
	}

	getActivityAdditionalMessages(): string[] {
		return [];
	}

	getActivityType(): string {
		return `TRANSACTION`;
	}

	getCreationDate(): moment.Moment {
		return this.creationDateTime;
	}

	getId() {
		return this.id;
	}

	/**
	 * Get user display name.
	 */
	getUserDisplayName(): string {
		return this.creator.getDisplayName();
	}
}

export enum TransactionEventTypeEnum {
	PaymentReceived = "RECEIVED",
	PaymentReconciled = "RECONCILED",
	PaymentPartiallyReconciled = "PARTIALLY_RECONCILED",
	Note = "TRANSACTION_NOTE",
	UndoReconciliation = "UNDO_RECONCILIATION"
}

export type TransactionEventType = TransactionEvent
	| TransactionPaymentReceivedEvent
	| TransactionPaymentReconciledEvent
	| TransactionPaymentUnreconciledEvent
	| TransactionPaymentPartiallyReconciledEvent;
